export default {
  title: "Trading Points",
  name: "Trading Point Name",
  namingNoSpecified: "Name not specified",
  tradingPoint: "Trading Point",
  addressNoSpecified: "Address not specified",
  info: "Trading Point Information",
  add: {
    title: "Create Trading Point",
    noOperations: "No operations have been performed",
  },
  historyOperation: "Receipt History",
  employee: "Employee",
  customer: "Customer",
  source: "Source",
  typeOperation: "Operation Type",
  typeActivity: "Activity Type",
  writing: "Debit",
  accrual: "Accrual",
  sumBuy: "Purchase Amount",
  sumWrite: "Debit Amount",
  toPay: "To Pay",
  totalCashback: "Total Reward",
  salePopup: "Discount",
  types: {
    balance_up: "Balance Top-up",
    balance_down: "Funds Debit",
    tsp_approve: "Settlement by Receipt",
    balance_refill: "Balance Top-up",
    tariff_change: "Tariff Purchase",
    cashback_approve: "Customer Journey",
    cashback_charge: "Receipt. Points Debit",
    certificate_charge: "Accrual. Gift Card Usage",
    certificate_debt: "Debit. Gift Card Issuance",
    certificate_refund: "Refund for Gift Card Issuance",
    rc_withdraw: "Receipt. Points Acceptance",
    tsp_commission_fee: "Receipt. Commission",
    tsp_commission_revert:
      "Additional accrual of incorrectly debited amount for period from April 1 to accrual date",
    tsp_commission_correct: "Settlement adjustment of 1% of accepted points",
    manual_commission_approve: "Receipt. Commission Settlement",
    manual_withdraw: "Funds Withdrawal",
    cashback_decline: "Receipt Cancellation",
    rc_processing_receipts: "Cash Register Receipt",
    cashback_approve_decline: "Cancellation of Customer Journey Accrual",
    partner_manual_withdraw: "Funds Debit",
    inner_cashback_charge: "Receipt. Reward Debit",
    inner_cashback_approve: "Settlement by Receipt",
    tsp_approve_payment: "Receipt. Funds Debit",
    rc_withdraw_approve: "Receipt. Accrual for Points Payment",
    withdraw_payment: "Receipt. Funds Debit",
    prodazha_top_mesta: "Top Placement Purchase in rcpay",
    reserving_funds_withdrawal: "Reserved for Payment",
    refund_reserved_funds_withdrawal: "Reserve Return for Payment",
    withdraw_reserved_funds: "Funds Withdrawal",
  },
  organizations: "Legal Entity",
  moderationModalTitle: "Message from Moderation",
  clients: "to client: ",
  other: "commission: ",
  total: "Total: ",
  draft: "Draft",
  itsAppearAfterCreateShop:
    "They will appear here after creating a trading point",
  inRCPay: {
    published: "Published in RC PAY",
    unpublished: "Not Published in RC PAY",
  },
  promotion: "Promotion",
  openInRCPay: "Open in RC PAY",
  couldntSendShopToModeration: "Could not save trading point",
  shopChangesSuccessSaved: "Trading point data changes successfully saved",
  forLayoultyCreateEmployee:
    "To work with the loyalty program, you need to create a cashier in the 'Cashiers' subsection, assigning them to this trading point.",
  changesSendedToModeration:
    "Trading point data changes submitted for moderation",
  someChangesNeedModeration: "Some of the changes made require moderation",
  changesUpdateAfterModeration:
    "In the establishment card displayed in RC PAY, they will only update after being checked and confirmed by a moderator.",
  connectedPaymentMethod: "Payment methods are connected to the trading point.",
  ifNeedDeleteConnectWithUs:
    "If you need to delete it, please contact technical support",
  ifNeedDeleteConnectWithUsSuccess: "Email copied",
  someFieldsUncorrect: "Some fields are filled incorrectly",
  backToEditingToFixIt:
    "Return to editing to fix them. Or click 'Skip' if you want to exit without saving data in fields with errors.",
  wannaQuit: "Want to quit?",
  allNotSavedChangesWillRemove:
    "All unsaved changes will be lost. To save them, go back.",
  cancelCreationPointModal: {
    title: "Cancel trading point creation?",
    subtitle:
      "Entered trading point information will not be saved. To return to editing, click 'Back'.",
  },
  moderationModal: {
    title: "Trading point successfully created and submitted for moderation",
    subtitle:
      "To work with the loyalty program, you need to create a cashier in the 'Cashiers' subsection, assigning them to this trading point.",
  },
  deletePromotionModal: {
    title:
      "Are you sure you want to delete a trading point with an active promotion service?",
    subtitle:
      "After deletion, promotion services will be discontinued. Funds paid for promotion will not be refunded. It will be impossible to restore the trading point data.",
  },
  deleteModal: {
    title: "Are you sure you want to delete the trading point?",
    subtitle: "After deletion, it will be impossible to restore the data.",
    shopDeleted: "Trading point deleted",
  },
  lessTariffModal: {
    title: "You've created the maximum number of trading points on your tariff",
    subtitle:
      "To create more trading points, you need to purchase a different tariff.",
  },
  validation: {
    specifyMailOrRemoveField: "Specify email address or remove the field",
    specifyLinkAddressOrRemove: "Specify link address or remove the field",
    couldntSendShopToModeration:
      "Could not submit trading point for moderation",
    someImagesCouldntProcess:
      "Some images could not be processed. Try uploading different ones",
  },
  creationTab: {
    main: "Basic",
    loyalty: "Loyalty Program",
    addressAndOpeningHours: "Address and Opening Hours",
    contacts: "Contacts",
    foto: "Photos",
  },
  stepFromTo: "Step {from} of {total}",
  createShopAndContinue: "Create TP and Continue",
  message: {
    dataSavedToDraft: "Trading point data saved to draft",
    dataSavedAndSendToModeration: "Changes saved and submitted for moderation",
    dataSuccessSaved: "Changes successfully saved",
    fillCorrectSpecifiedFields: "Correctly fill the specified fields",
    fillCorrectAllRequiredFields: "Correctly fill all required fields",
  },
  describeYourCompany:
    "Describe your company in detail. Please do not use hashtags (#) and emojis in the text. Addresses, contact details, and operating hours are specified separately - in the following tabs.",
  willDisplayToUserInRCPay: "Will be displayed to users in RC PAY",
  activityTooltip:
    "The establishment will be displayed in search results in RC PAY when filtering by selected categories.",
  afterModerationEntityEditingDisable:
    "After moderator confirmation, editing the legal entity is unavailable. To make changes, contact technical support.",
  description: "Trading Point Description",
  charsLimit: {
    min: "Minimum characters - {minChars}",
    max: "Maximum characters - {maxChars}",
  },
  features: "Features",
  selectedFeaturesWillDisplayInCard:
    "Selected options will be displayed in your establishment card in RC PAY as tags",
  catalogTitles: "Product/Services Block Title in RC PAY",
  catalogTitlesTooltip:
    "General name for the block with list of trading point products/services. Applies only on your establishment page in RC PAY.",
  totalPercentReward: "Total Reward Percentage",
  totalPercentRewardValue: "Total accruable reward percentage (from 4 to 25).",
  rewardWillPayToClients:
    "Clients will be paid amounts according to reward distribution scenarios.",
  checkRewardDistribution: "See reward distribution scenarios",
  activeWait: "Accrual Delay",
  activeWaitTooltip:
    "Number of days (from 0 to 14) from customer's purchase after which the reward will be accrued",
  clientDiscount: "RC PAY Customer Discount",
  clientDiscountTooltip:
    "Discount percentage (from 0 to 99) that will be provided to RC GROUP loyalty program customers when making purchases at the trading point",
  shopPaylable: "Trading point accepts RC points payment",
  shopPaylableDescription:
    "Customers registered in RC PAY will be able to pay up to 99.9% of purchase value with RC points",
  enteredDataNotNeedModeration:
    "Entered data does not require moderation and is applied immediately after creating the trading point or saving changes during editing (if legal entity is confirmed).",
  address: "Address",
  ifNoYourShopSelectNear:
    "If your establishment's address is not on the map, select the nearest one and contact technical support to set the correct address",
  startEnteringAddress: "Start typing and select address from list",
  addressComment: "Address Comment",
  specifyWayToGetYouShop:
    "Specify how to get to your establishment, need to call in advance, or any other additional information (optional)",
  period: {
    workdays: "Weekdays MON-FRI",
    weekend: "Weekends SAT-SUN",
    allDay: "Daily MON-SUN",
    aroundClock: "24/7 Around the Clock",
  },
  catalog: "Catalog",
  intervals: "Intervals",
  weekdays: "Days of Week",
  selectedAllDays: "All days of week selected",
  workHoursInOtherDays: "Working Hours on Other Days",
  workDays: "Working Days",
  workDaysMobileSubtitle:
    "Select interval or specific days of week when the trading point operates on one schedule (working hours are the same for all days selected in this field).",
  workDaysTooltips: [
    "Select interval or specific days of week when the trading point operates on one schedule (e.g., Weekdays MON-FRI from 10:00 to 20:00).",
    "Then click 'Working Hours on Other Days' and select days when establishment hours differ (e.g., SAT from 12:00 to 16:00).",
  ],
  specifyWorkTimeInSelectedDays: "Specify working hours on selected days",
  publicTradingPoint: "Publish trading point on rcpay.ru",
  publicTTDescription: [
    "The trading point will be displayed on rcpay.ru website in the establishments list and in RC PAY mobile app within the city where it's located.",
    "Establishment placement in RC PAY is only possible after moderator confirmation. To remove from placement, disable this option, moderation is not required.",
  ],
  workOnline: "Trading point operates online",
  workOnlineDescription: [
    "Provided services/goods are implemented only remotely/for delivery.",
    "In the 'Address' field, specify approximate address for placing the trading point on city map - it won't be shown in establishment card in RC PAY, instead the word 'Online' will be displayed.",
  ],
  time: "Working Hours",
  specifyPhoneNumberOrRemove: "Specify phone number or remove the field",
  specifyMailOrRemove: "Specify email or remove the field",
  onlineService: "Online Booking Service",
  specifyLinkIfUseOtherServicesForOnline:
    "Specify link here if you use ready-made services for online customer booking",
  linkAddress: "Link Address",
  addSiteOrSocialMedia: "Add links to website or social media",
  linkName: "Link Name",
  linkNameTooltips: [
    "Specify how you want the link to be displayed in RC PAY. For example, 'Buy' or 'Book'.",
    "If nothing is specified, the link address will be displayed.",
  ],
  pointPhotos: "Trading Point Photos",
  photosRequirements:
    "Should be in maximum quality, without watermarks, text, and collages",
  logo: "Logo",
  photoRecomendation: "Image Recommendations",
  logoRecomendations: [
    "JPEG, JPG, PNG file up to 10 MB, aspect ratio — 1:1",
    "Logo, thematic image, image with name or trademark of your establishment will work",
    "High-quality image that doesn't contain address, phone number and other additional information",
  ],
  uploadLogo: "Upload Logo",
  noClient: "No Client",
  giftCard: "Gift Card",
  totalCashbackHints: [
    "The receipt shows total reward percentage, but the amount in receipt may not match the actual debited points amount shown in operation line.",
    "This depends on which customer made the purchase (internal or external) and their tariff.",
  ],
  previewInRCPay: "Preview in RC PAY",
  searchByTable: "Search Table",
};
